__turbopack_context__.v({
  "className": "manrope_44e4ccc7-module__JeiX6q__className",
});
